import {
  GRADE_LIST_START,
  GRADE_LIST_ERROR,
  GRADE_LIST_SUCCESS,
  PRINT_GRADE_LIST_START,
  PRINT_GRADE_LIST_ERROR,
  PRINT_GRADE_LIST_SUCCESS,
  SET_SMA_DATA,
  SMA_RESET_ERRORS,
  SMA_CHANGE_BASIS,
  SMA_GET_UDFS_SUCCESS,
  SMA_GET_UDFS_ERROR
} from '../actions/GradeListActions';
import { CLICKED_GRADE, BACK_TO_LIST } from '../actions/ViewGradeActions';
import { HIDE_SLIDEOUT } from 'ps-components/Slideout/SlideoutReducer';
import { SLIDEOUT_STATUS } from './SlideoutStates';

export const MODEL_TYPE = {
  NEW: 'NEW',
  NEW_BASED: 'NEW_BASED',
  EXISTING: 'EXISTING'
};

export const initialState = {
  slideoutStatus: SLIDEOUT_STATUS.LIST,
  gradeInfo: [],
  totals: null,
  structureData: {
    modelName: null,
    modelId: null,
    modelType: null
  },
  gradeListLoading: false,
  requestError: null,
  isPrinting: false,
  basis: 'base',
  udfList: []
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case CLICKED_GRADE:
      return {
        ...state,
        slideoutStatus: SLIDEOUT_STATUS.VIEW
      };
    case SMA_CHANGE_BASIS:
      return {
        ...state,
        basis: action.basis
      };
    case SMA_GET_UDFS_SUCCESS:
      return {
        ...state,
        udfList: action.udfList
      };
    case SMA_GET_UDFS_ERROR:
      return {
        ...state,
        requestError: true
      };
    case BACK_TO_LIST:
      return {
        ...state,
        slideoutStatus: SLIDEOUT_STATUS.LIST
      };
    case HIDE_SLIDEOUT:
      return {
        ...initialState
      };
    case GRADE_LIST_START:
      return {
        ...state,
        gradeListLoading: true,
        requestError: null
      };
    case GRADE_LIST_ERROR:
      return {
        ...state,
        gradeListLoading: false,
        requestError: true
      };
    case GRADE_LIST_SUCCESS:
      return {
        ...state,
        gradeInfo: action.payload.data.result?.result,
        totals: action.payload.data.result.totals,
        structureData: {
          ...state.structureData,
          modelName: action.payload.data.result.modelName,
          modelType: action.payload.data.result.modelType
        },
        gradeListLoading: false,
        requestError: false
      };
    case SET_SMA_DATA:
      return {
        ...state,
        structureData: {
          ...state.structureData,
          modelId: action.payload.modelId
        }
      };
    case SMA_RESET_ERRORS:
      return {
        ...state,
        requestError: null,
        printError: null
      };
    case PRINT_GRADE_LIST_START:
      return {
        ...state,
        isPrinting: true
      };
    case PRINT_GRADE_LIST_SUCCESS:
      return {
        ...state,
        isPrinting: false,
        requestError: false
      };
    case PRINT_GRADE_LIST_ERROR:
      return {
        ...state,
        isPrinting: false,
        requestError: true
      };
    default:
      return state;
  }
}
